// @flow
import type { ID } from '../../core/types'
import type { Charity } from './types'
import { createSelector } from 'reselect'
import values from 'lodash/values'
import { getById, getDomain } from '../../modules/entities'
import { domains } from '../constants'
import getImageSource from '../mycharity/media/getImageSource'

export const getCharity = (id: ID) =>
  createSelector(getById(domains.CHARITIES, id), (charity: Charity) => {
    return charity
      ? {
          ...charity,
          photo: getImageSource(charity.photo),
          photo_thumb: !getImageSource(charity.photo_thumb)
        }
      : null
  })

/* export const getCharity = (id: ID, state: AppState): Charity => {
  const charity = getById(domains.CHARITIES, id, state)
  return {
    ...charity,
    photo: !!charity ? getImageSource(charity.photo) : null,
    photo_thumb: !!charity ? getImageSource(charity.photo_thumb) : null
  }
} */

export const getCharitySelector = (id: ID) => getById(domains.CHARITIES, id)

export const makeCharityContactsSelector = (charityId: ID) =>
  createSelector(getDomain([domains.CONTACTS]), allContacts =>
    values(allContacts).filter(contact => contact.charityId === charityId)
  )



// WEBPACK FOOTER //
// ./src/services/charity/selectors.js